import React from 'react';
import { connect } from 'react-redux';

import { pickCollectionListings } from '../../util/listingCollections';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { selectListingCollection } from '../../ducks/listingCollections.duck';
import ListingCollection from '../../components/ListingCollection/ListingCollection';
import { listingPageCollections } from '../../config/configListingCollections';

/**
 * Renders the listing page collections ("Similar listings", "More from this seller").
 * The listings are fetched in ListingPage.duck loadData; each collection renders nothing
 * until it has listings of its own.
 *
 * A seller's other listing is often also a similar listing, so each collection is told which
 * listings the collections above it already used, and shows the same listing only once.
 *
 * @component
 * @param {Object} props
 * @param {string} props.listingId uuid of the listing on screen, filtered out of the results
 * @param {string?} props.authorDisplayName used in the "More from ..." heading
 * @param {Object} props.listingsByCollectionId denormalised listings keyed by collection id
 * @returns {JSX.Element}
 */
export const SectionListingCollectionsComponent = props => {
  const { listingId, authorDisplayName, listingsByCollectionId = {} } = props;

  // Same inputs and same function as the collection itself, so both resolve to the same listings.
  const alreadyShown = [];
  const collectionsWithExclusions = listingPageCollections.map(collection => {
    const excludeListingIds = [...alreadyShown];
    const picked = pickCollectionListings(listingsByCollectionId[collection.id], {
      excludeListingId: listingId,
      excludeListingIds,
      limit: collection.limit,
    });
    picked.forEach(listing => alreadyShown.push(listing.id.uuid));

    return { collection, excludeListingIds };
  });

  return (
    <>
      {collectionsWithExclusions.map(({ collection, excludeListingIds }) => (
        <ListingCollection
          key={collection.id}
          collection={collection}
          excludeListingId={listingId}
          excludeListingIds={excludeListingIds}
          titleValues={{ authorName: authorDisplayName }}
        />
      ))}
    </>
  );
};

const mapStateToProps = state => {
  const listingsByCollectionId = listingPageCollections.reduce((acc, collection) => {
    const { listingIds } = selectListingCollection(state, collection.id);
    return { ...acc, [collection.id]: getListingsById(state, listingIds) };
  }, {});

  return { listingsByCollectionId };
};

const SectionListingCollections = connect(mapStateToProps)(SectionListingCollectionsComponent);

export default SectionListingCollections;
